export default __webpack_public_path__ + "static/media/png.fa59c14a.svg";